// TODO: I'd like to support this, but can't reliably get back from T to metadata in all cases
// type MetadataReuse = {
//     writeStrategy: "reuse";
//     flavor: MetadataFlavor;
// };
export const MetadataNone = {
    writeStrategy: "none",
    flavor: "none",
};
export function metadataStrategyOverwrite(flavor) {
    return {
        writeStrategy: "overwrite",
        flavor,
    };
}
export function metadataStrategySpecify(flavor, metadata) {
    return {
        writeStrategy: "specify",
        flavor,
        metadata,
    };
}
//# sourceMappingURL=strategy.js.map